import { fillArr, getByOrder } from '@hglobal/fin-ui';
import { GetWalletsRes } from 'app/pages/wallets/models';

import { Provider, WalletCard } from '@kr/models';
import { getCoinsMock } from '@kr/store';

export function getWalletMock(i: number, provider: Provider): WalletCard {
  const coins = getCoinsMock();

  return {
    id: String(i),
    name: `Crypto${i}`,
    balanceAvailable: `${i * 10}204056.077`,
    networkBalance: `${i * 10}5.077`,
    coinId: getByOrder(i, coins).id,
    orgId: 1,
    secondaryWalletCoinId: +getByOrder(i, coins).id + 1,
    coin: getByOrder(i, coins),
    secondaryWalletCoin: getByOrder(i + 1, coins),
    address: '0x2BFf94f8c712Ba8F71B54069A1eD1779f3E9Ad22',
    active: true,
    organizationId: i,
    organizationType: provider.type,
  };
}

export function getWalletsMock(provider: Provider): GetWalletsRes {
  const walletMock = fillArr(2, i => getWalletMock(i, provider));

  return {
    itemsCount: walletMock.length,
    wallets: walletMock,
  };
}
